export default "__VITE_ASSET__CIEsjtBa__"